export default __webpack_public_path__ + "static/974-45bd8003168c3bd63da45c831138ba1e.gif";